import * as React from 'react'
import styles from './style.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import _, { isEmpty } from "lodash";
import clsx from 'clsx';
import { ReactComponent as LOCATION } from '../../../../../static/IconProvider/location.svg'
import { ReactComponent as ADDRESS_BOOK } from '../../../../../static/IconProvider/address_book.svg'
import { ReactComponent as INFO_CIRCLE } from '../../../../../static/IconProvider/info-circle.svg'

import { UseCRUDDropoffs } from '../../../../../service/hooks/useCRUD_Dropoffs';
import { getCenterMap, setCenterMap } from '../../../../../helper/module';
import { ChooseoOnMapimg, RemoveAddressBookFromList, Set_DropOff_Inputs, Set_latlng, Set_SearchAutoCompleteLoading, SetopenAddressBookInNewOrder } from '../../../../../Redux/actions/actionNames';
import { Api_Add_Addressbook_AGW, Api_Delete_Addressbook_AGW, Api_Get_Addressbook_list_AGW, Api_map_geocoding_reverse_AGW, Api_PlaceIdDetails_AGW, Api_SearchAutoComplete_AGW } from '../../../../../helper/api/ApiGateway';
import AddressItem from './components/addressItem';
import {  CLOSE_DARK, CUSTOMER_TYPE, DRAG, DROPOFF } from '../../../../../static';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import Typography from '../../../../../design-system/lib/Typography';
import SearchList from '../../../../../design-system/lib/SearchList';
import DropDown from '../../../../../design-system/lib/DropDown';
import Button from '../../../../../design-system/lib/Button';
import DeliveryInfoNewOrder from './components/info';
import IconProviderSvgModifier from '../../../../../design-system/lib/IconProviderSvgModifier';
import search_not_found_gray from '../../../../../static/search_not_found_gray.svg'
import Schedule from '../Schedule/Schedule';
import service_point from '../../../../../static/IconProvider/service_point.svg';
import service_point_color from '../../../../../static/IconProvider/service_point_color.svg';
import danger from '../../../../../static/IconProvider/danger.svg';
import location_gray from '../../../../../static/IconProvider/location_gray.svg';

import ServicePoint_addressItem from './components/servicePoint_addressItem';
import { ServicesApi } from '../../../../../service/api/service';
import { get_customerPannel_type, Get_Permisssion } from '../../../../../helper/UserData/userdate';
import { SucceessFul_i18 } from '../../../../../helper/Notification/sendNotification';
import { ReactComponent as BookmarkInActive } from '../../../../../static/IconProvider/bookmarkInActive.svg'
import { ReactComponent as Bookmarkactive } from '../../../../../static/IconProvider/Bookmarkactive.svg'
import Modal from '../../../../../design-system/lib/Modal';
import Input from '../../../../../design-system/lib/Input';
import {  PERSON, WARNING } from '../../../../../static';


function DeliveryNewOrder({ handleCollapse, dropOffsCount, isDraggingOver, index, last, first, addDropOff, id, removeDrop, orderTypeActive, dropOffCount, ...props }) {
  let { items, sEtItems } = UseCRUDDropoffs()


  const [ordered, setOrdered] = React.useState(true);
  const [showpoper, setShowpoper] = React.useState(false);
  const [showpoperSaved, setShowpoperSaved] = React.useState(false);
  const [getFavAddressLoading, setGetFavAddressLoading] = React.useState(false);
  const [searchAddrees, setSearchAddrees] = React.useState("");
  const [sessionToken, setSessionToken] = React.useState(null);
  const pickupDropOffType = useSelector((state) => state.NewOrder.newOrder.map_Data.pickupDropOff.type)
  const pickupDropOffId = useSelector((state) => state.NewOrder.newOrder.map_Data.pickupDropOff.id)
  const ActivescheduleSetting = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType ? (state.NewOrder.newOrder.service.activeVehicleType.scheduleSetting.isActive ? state.NewOrder.newOrder.service.activeVehicleType.scheduleSetting.hasDropoffScheduling : false) : false)


  const addressDetail = props.addressDetail;
  const block = props.block;
  const floor = props.floor;
  const unit = props.unit;
  const email = props.email;
 
  const noteForDriver = props.noteForDriver;
  
  const [modalAddActive, setModalAddActive] = React.useState(false);
  const [modalDelActive, setModalDelActive] = React.useState(false);
  const Addressbooklist = useSelector((state) => state.Addressbook.list)
  const [modalAddData, setModalAddData] = React.useState({title: null , code : null});

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const mapRef = useSelector((state) => state.Map.mapRef)
  const center = useSelector((state) => state.Map.center)
  const adresss_loc = props.adresss_loc;
  const emailg = props.email
  const senderFullName = props.recieverFullName
  const senderPhoneNumber = props.recieverPhoneNumber
  const activePickupDropOff = useSelector((state) => state.NewOrder.newOrder.activePickupDropOff)
  const suggestListPickUpDropOffLoading = useSelector((state) => state.NewOrder.newOrder.suggestListPickUpDropOffLoading)
  const suggestPickUpDropOffListData = useSelector((state) => state.NewOrder.newOrder.suggestPickUpDropOffListData)
  const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const serviceactiveVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const delayedQuerySP = React.useCallback(_.debounce((...pr) => HandleChangeSP(...pr), 500), []);


  const delayedQuery = React.useCallback(_.debounce((...pr) => HandleChange(...pr), 500), []);
  const openAddressBook = useSelector((state) => state.Addressbook.openAddressBookInNewOrder)
  const addressBookSource = useSelector((state) => state.Addressbook.openAddressBookInNewOrder
    ? state.Addressbook.sourceOfAddressBookInNewOrder
      ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "dropoff" &&
      id == state.Addressbook.sourceOfAddressBookInNewOrder.id
      : false
    : false)

    const deliveryLocationType = useSelector((state) => state.NewOrder.newOrder.deliveryMethod?.dropoffLocationType)
    const deliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)

    const [servicepoints, setServicepoints] = React.useState([]);
    const [servicepointsIsLoading, setServicepointsIsLoading] = React.useState(false);

  React.useEffect(() => {
    if (deliveryLocationType != "address" && deliveryMethod?.id) {
      (async () => {
        setServicepointsIsLoading(true)
        const Services = new ServicesApi();
        const ServicePoints = await Services.ServicePoints({
          deliveryMethodId: deliveryMethod?.id,
          locationType: "dropoff"
        })
        console.log("ServicePoints5 ", ServicePoints)
        setServicepoints(ServicePoints)
        setServicepointsIsLoading(false)

      })();
    }
  }, [deliveryLocationType, deliveryMethod])

    

    const GetserachListItemOnclickSP = React.useCallback((item) => {

      console.log("dwdwd dw ws dw ",item)

      dispatch(
        Set_latlng({ lng: item.coordinates.lng, lat: item.coordinates.lat })
      );
      dispatch(Set_DropOff_Inputs({
        name: "idx",
        value: item.id,
        firstDropOff: first,
        id: id == "dropoff" ? "dropoff" : id,
      }))
      dispatch(Set_DropOff_Inputs({
        name: "name",
        value: item.name,
        firstDropOff: first,
        id: id == "dropoff" ? "dropoff" : id,
      }))
      dispatch(Set_DropOff_Inputs({
        name: "address",
        value: item.address,
        firstDropOff: first,
        id: id == "dropoff" ? "dropoff" : id,
      }))
      dispatch(Set_DropOff_Inputs({
        name: "adresss_loc",
        value: { lng:  item.coordinates.lng, lat: item.coordinates.lat },
        firstDropOff: first,
        id: id == "dropoff" ? "dropoff" : id,
      }))
  
   
      mapSetView({
        lng: item.coordinates.lng,
        lat: item.coordinates.lat,
      });
  }, [first, id]);


    
    const HandleChangeSP = React.useCallback( async (value ,  juyy) => {

      console.log("fewfewscfewf ", value )
        setServicepointsIsLoading(true)
        const Services = new ServicesApi();
          const ServicePoints = await Services.ServicePoints({
            deliveryMethodId:juyy?.id,
            locationType:"dropoff",
            search:value
          })
          console.log("ServicePoints5 ", ServicePoints)
          setServicepoints(ServicePoints)
          setServicepointsIsLoading(false)

  
    }, [deliveryMethod]);



  const HandleChange = React.useCallback((value,  sessionToken) => {

    let centerr = getCenterMap(mapRef, center)
    String(value).length > 0 && dispatch(Set_SearchAutoCompleteLoading(true));

      String(value).length > 0 && Api_SearchAutoComplete_AGW(dispatch, {
          query: value,
          latitude: centerr.lat,
          longitude: centerr.lng,
          sessionToken: sessionToken
        })
      


  }, [ sessionToken]);


  const handleSearchSPInput = React.useCallback((e, name) => {
    if (e?.target?.ignore) {
      return null
    }
    if (name === "address" || e?.target.id === "address") {
      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuerySP(e?.target.value , deliveryMethod)

        console.log("fewfewscfewf ss", e?.target.value )

        if(e?.target?.value.length == 0 && props.address?.length > 0 ){
          delayedQuerySP(e?.target.value, deliveryMethod)
          console.log("fewfewscfewf ss", e?.target.value )

        }
       }else if (e?.target?.value.length == 0 , deliveryMethod) {
        delayedQuerySP("" , deliveryMethod)
        console.log("fewfewscfewf ss", "" )

       }
    }

    if(e){
        dispatch(
      Set_DropOff_Inputs({
        name: name || e?.target.id,
        value: e?.target.value,
        firstDropOff: first,
        id: id == "dropoff" ? "dropoff" : id,
      })
    );
    }
  
  }, [ id, first , deliveryMethod]);



  const handlePickUpInputs = React.useCallback((e, name) => {

    if (name === "address" || e?.target.id === "address") {

      setSessionToken(sessionToken ? sessionToken : uuidv4())



      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuery(e?.target.value,  sessionToken)
      }

    }

    if(e){
        dispatch(
      Set_DropOff_Inputs({
        name: name || e?.target.id,
        value: e?.target.value,
        firstDropOff: first,
        id: id == "dropoff" ? "dropoff" : id,
      })
    );
    }
  
  }, [sessionToken,  id, first]);


  const notThrottleHandleChange = React.useCallback((value) => {

    let centerrr = getCenterMap(mapRef, center)
    String(value).length > 0 && dispatch(Set_SearchAutoCompleteLoading(true));


      String(value).length > 0 && Api_SearchAutoComplete_AGW(dispatch, {
          query: value,
          latitude: centerrr.lat,
          longitude: centerrr.lng,
          sessionToken: sessionToken
        })


  }, [ sessionToken]);


  React.useEffect(() => {
    notThrottleHandleChange(String(props.address), sessionToken)
  }, [])


  const serachListData = React.useCallback(() => {

        if (deliveryLocationType != "address") {
          if (servicepoints && !_.isEmpty(servicepoints)) {
            return servicepoints
          } else {
            return null
          }
        }
    


    if (_.isEmpty(props.address)) {
            return null 
    } else {
      if (_.isEmpty(suggestPickUpDropOffListData)) {
        return null 
      } else {
        return suggestPickUpDropOffListData
      }
    }


  }, [ props.address, suggestPickUpDropOffListData , deliveryLocationType , servicepoints]);


  const GetserachListItem = React.useCallback(() => {
      return AddressItem
  }, [ props.address, suggestPickUpDropOffListData]);


  const GetserachListItemOnclick = React.useCallback(() => {


      return handleList
    


  }, [ props.address, suggestPickUpDropOffListData]);


  const GetSearchListError = React.useCallback(() => {

  
   if (deliveryLocationType != "address") {
      if (_.isEmpty(props.address)) {
        if (!servicepoints || _.isEmpty(servicepoints)) {
          return {
            errorTitle: t("No service point available"),
            errorIcon: service_point,
          }
        } else {
          return null
        }
     } else if (!_.isEmpty(props.address)) {
      if ((!servicepointsIsLoading && (servicepoints?.length == 0 || _.isEmpty(servicepoints)))) {
        return {
          errorDescription: t("NoResultfromLocalDatabaseD"),
          errorIcon: null,
        }
      }
  }
    }else {
      if ((!suggestListPickUpDropOffLoading &&
        suggestPickUpDropOffListData.length === 0 && !_.isEmpty(props.address)) || (!_.isEmpty(props.address) && !suggestListPickUpDropOffLoading && !suggestPickUpDropOffListData)) {
        return {
          errorDescription: t("NoResultfromLocalDatabaseD"),
          errorTitle: t("Noresultfound"),
          errorIcon: search_not_found_gray,
          errorActionTitle:t("Clearfield")
        }
      }
    }

    

  }, [ props.address, servicepoints , servicepointsIsLoading , suggestPickUpDropOffListData, suggestListPickUpDropOffLoading , deliveryLocationType ,]);

  const handleRecentList = React.useCallback((item) => {

    dispatch(
      Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
    );

    dispatch(Set_DropOff_Inputs({
      name: "address",
      value: item.address,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "adresss_loc",
      value: { lng: item.coordinates[0], lat: item.coordinates[1] },
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "block",
      value: item.buildingBlock,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "floor",
      value: item.floor,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))

    dispatch(Set_DropOff_Inputs({
      name: "unit",
      value: item.room,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    mapSetView({
      lng: item.coordinates[0],
      lat: item.coordinates[1],
    });

    handleShowInfo()

  }, [first, id]);

  const mapSetView = (e) => {
    setCenterMap(mapRef, e)
  };
  const handleList = React.useCallback((item) => {

    if(!item){
      return null
    }


    if (item.coordinates) {

      dispatch(
        Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "address",
          value: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "adresss_loc",
          value: {
            lng: item.coordinates[0],
            lat: item.coordinates[1],
          },
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      mapSetView({
        lng: item.coordinates[0],
        lat: item.coordinates[1],
      });

      setSessionToken(null)

      handleShowInfo()

    } else {

      let ss = sessionToken ? sessionToken : uuidv4()
      setSessionToken(ss)


        Api_PlaceIdDetails_AGW(dispatch, { placeId: item.placeId, sessionToken: ss }, (res) => {

          setSessionToken(null)


          dispatch(
            Set_latlng({ lng: res.coordinates[0], lat: res.coordinates[1] })
          );

          dispatch(
            Set_DropOff_Inputs({
              name: "address",
              value: res.address,
              firstDropOff: first,
              id: id == "dropoff" ? "dropoff" : id,
            })
          );
          dispatch(
            Set_DropOff_Inputs({
              name: "adresss_loc",
              value: {
                lng: res.coordinates[0],
                lat: res.coordinates[1],
              },
              firstDropOff: first,
              id: id == "dropoff" ? "dropoff" : id,
            })
          );
          dispatch(
            Set_latlng({
              lng: res.coordinates[0],
              lat: res.coordinates[1],
            })
          );
        })
      

      handleShowInfo()
    }

        dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
    
  }, [first, id]);

  const resetPickup = React.useCallback(() => {


    if (first && adresss_loc.lat != "" && dropOffCount > 1) {

      dispatch(
        Set_DropOff_Inputs({
          name: "address",
          value: items[1].address,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "adresss_loc",
          value: items[1].adresss_loc,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "placeId",
          value: items[1].placeId,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );



      dispatch(
        Set_DropOff_Inputs({
          name: "block",
          value: items[1].block,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "driver",
          value: items[1].driver,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "email",
          value: items[1].email,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "floor",
          value: items[1].floor,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "recieverFullName",
          value: items[1].recieverFullName,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "recieverPhoneNumber",
          value: items[1].recieverPhoneNumber,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "scheduleDateAfter",
          value: items[1].scheduleDateAfter,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      dispatch(
        Set_DropOff_Inputs({
          name: "scheduleDateBefore",
          value: items[1].scheduleDateBefore,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "unit",
          value: items[1].unit,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      handleCollapse({
        type: null,
        id: ""
      });

      removeDrop(items[1].id)
    } else {

      dispatch(
        Set_DropOff_Inputs({
          name: "address",
          value: "",
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "adresss_loc",
          value: { lng: "", lat: "" },
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "placeId",
          value: "",
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      handleCollapse({
        type: null,
        id: ""
      });
    }


  }, [first, id, items, adresss_loc, dropOffCount]);



  const handleShowInfo = React.useCallback(() => {

    const isOpen = activePickupDropOff.id == id

    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);


    if (!isOpen) {
      handleCollapse({
        type: "dropoff",
        id: id,
        firstDropOff: first
      });
    } else {
      setTimeout(() => {
        handleCollapse({
          type: null,
          id: ""
        });
      }, 100);
    }

  }, [first, id, activePickupDropOff]);




  const ChooseoOnMap = React.useCallback(() => {


    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);


     if (
      (pickupDropOffType == "DropOff") ? (first ? pickupDropOffId == null : pickupDropOffId == id ) : false
     ) {
       dispatch(
         ChooseoOnMapimg({
           showMap: false,
           pickupDropOff: {
             type: null,
            id: null,
           },
         })
       );
     } else {
         let centerc = getCenterMap(mapRef, center);
    Api_map_geocoding_reverse_AGW(dispatch, {
      latitude: mapRef.current
        ? centerc.lat
        : centerc.lat,
      longitude: mapRef.current
        ? centerc.lng
        : centerc.lng,
    });
    dispatch(
      ChooseoOnMapimg({
        showMap: true,
        pickupDropOff: {
          type: "DropOff",
          id: id == "d123" ? null : id,
        },
      })
    );
     }

 


  }, [first, id, activePickupDropOff , pickupDropOffType , pickupDropOffId]);



  const emailValidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }





  const pickupRequiredCheck = React.useCallback(() => {
    if (activeVehicleType) {
      let name = false, email = false, phone = false;

      if (activeVehicleType.setting.isDropoffAddressNameRequired) {
        if (senderFullName && String(senderFullName).trim().length > 0) {
          name = true
        } else {
          name = false
        }
      } else {
        name = true
      }

      if (activeVehicleType.setting.isDropoffAddressPhoneRequired) {
        if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
          phone = true
        } else {
          phone = false
        }
      } else {
        phone = true
      }


      if (activeVehicleType.setting.isDropoffAddressEmailRequired) {
        if (emailg && String(emailg).length > 0 && emailValidate(String(emailg))) {
          email = true
        } else {
          email = false
        }
      } else {
        email = true
      }



      return (name && phone && email);

    } else {
      return false
    }

  }, [activeVehicleType, emailg, senderPhoneNumber, senderFullName]);


  const handleOpenAddressbook = React.useCallback(() => {

    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);

    setTimeout(() => {
        if (openAddressBook && addressBookSource) {
          dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
        } else {
          dispatch(
            SetopenAddressBookInNewOrder(
              true,
              "dropoff",
              id,
              "AddressbookDropOf"
            )
          );
        }
      
    },
      100);
  }, [  openAddressBook, addressBookSource, id]);



  React.useEffect(() => {

    document.addEventListener('closeSliders', () => {

      handleCollapse({
        type: null,
        id: ""
      });

    })


    return () => {
    try {
        document.removeEventListener("closeSliders", () => {
  
          handleCollapse({
            type: null,
            id: ""
          });
    
        });
    } catch (error) {
      
    }
    };

  }, [])

  React.useEffect(() => {
    const isOpen = activePickupDropOff.id == id

    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);

    if (adresss_loc.lat != '') {
      if (!isOpen) {
        handleCollapse({
          type: "dropoff",
          id: id,
          firstDropOff: first
        });
      }
    }
  }, [adresss_loc])

    const detectOrderType = React.useCallback(() => {
  
      if (serviceactiveVehicleType?.orderTypes?.indexOf("PickupDelivery") > -1) {
        return "PickupDelivery"
      } else {
        return "Ondemand"
      }
  
    },[serviceactiveVehicleType])


    React.useEffect(() => {

      if(deliveryLocationType != "address" && isEmpty(props.name) && isEmpty(props.idx) && !isEmpty(String(adresss_loc.lat))){
        dispatch(
          Set_DropOff_Inputs({
            name: "address",
            value: "",
            firstDropOff: first,
            id: id == "dropoff" ? "dropoff" : id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "adresss_loc",
            value: { lng: "", lat: "" },
            firstDropOff: first,
            id: id == "dropoff" ? "dropoff" : id,
          })
        );
      }
  
  
      if(deliveryLocationType == "address" && !isEmpty(props.name) && !isEmpty(props.idx) && !isEmpty(String(adresss_loc.lat))){
        dispatch(
          Set_DropOff_Inputs({
            name: "address",
            value: "",
            firstDropOff: first,
            id: id == "dropoff" ? "dropoff" : id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "idx",
            value: null,
            firstDropOff: first,
            id: id == "dropoff" ? "dropoff" : id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "name",
            value: null,
            firstDropOff: first,
            id: id == "dropoff" ? "dropoff" : id,
          })
        );
        dispatch(
          Set_DropOff_Inputs({
            name: "adresss_loc",
            value: { lng: "", lat: "" },
            firstDropOff: first,
            id: id == "dropoff" ? "dropoff" : id,
          })
        );
      }
   
     }, [deliveryLocationType , props.name , props.idx])

     
       const checkInputFilledByAB = React.useCallback(() => {
         let status = false;
           Addressbooklist.forEach((element) => {
             if (element.address == props.address) {
               status = true;
             }
           });
           return status;
        
       }, [Addressbooklist, props.address ]);
     
       const getAddressbookId = React.useCallback(() => {
         let status = null;
           Addressbooklist.forEach((element) => {
             if (element.address == props.address) {
               status = element.id;
             }
           });
           return status;
        
       }, [Addressbooklist,props.address ]);
     
       const RemoveAddressBook = React.useCallback(() => {
         setModalDelActive(false)
         let xxx = getAddressbookId()
         Api_Delete_Addressbook_AGW(
           dispatch,
           xxx,
           (call) => {
             call &&
               dispatch(
                 RemoveAddressBookFromList(xxx)
               );
           }
         );
       }, [ Addressbooklist,props.address]);
     
       const UserHavePermission = React.useCallback(() => {
     
         if (get_customerPannel_type() == "business") {
           if (Get_Permisssion()?.isDefaultPickupAddressEditable) {
             return true
           } else if (props.adresss_loc.lat == '') {
             return true
           } else {
             return false
           }
     
     
         } else {
           return true
         }
     
       },[props.adresss_loc])
       
       const handleNewBookmark = React.useCallback(() => {
     
         Api_Add_Addressbook_AGW(dispatch, {
           "title": modalAddData.title,
           "address": props.address,
           // addressDetail : addressDetail ,
             "coordinates": [
                 props.adresss_loc.lng, props.adresss_loc.lat
             ], 
             "buildingBlock": block,
             "floor": floor,
             "fullName": senderFullName,
             "phone": senderPhoneNumber,
             "placeId": "",
             "room": unit,
             "code": modalAddData.code ? modalAddData.code  : "" ,
             email:email ,
             description:noteForDriver ,
         },(call)=>{
           if(call.loading){
             setModalAddActive(false)
           }else {
             setModalAddActive(false)
             setModalAddData({title: null , code : null})
             if(call.ok){
               SucceessFul_i18(
                 "Createdsuccessfully",
                 "networkError",
                 "close",
                 () => {
                   dispatch({
                     type: "removeNetworkErrorSnack",
                     key: "networkError",
                   });
                 },
                 new Date().getTime() + Math.random()
               );
               Api_Get_Addressbook_list_AGW(dispatch, {page:1 , perpage:20 , searchRegex:""}, false);
     
             }else{
               
             }
           }
         });
     
     
     //    setModalAddActive(false)
     
     
     },[senderPhoneNumber , addressDetail , props.address, props.adresss_loc,block ,floor , unit,senderFullName,noteForDriver ,email ,modalAddData ])
     

  if (isEmpty(String(adresss_loc.lat))) {

    let destinationShow =
    (pickupDropOffType == "DropOff") ? (first ? pickupDropOffId == null : pickupDropOffId == id ) : false

    return <div className={clsx(styles.PickupOnlyNewOrderContainer, styles.PickupDelivery)}>
      {["Ondemand"].indexOf(
        orderTypeActive
      ) > -1 && (
          <hr className={styles.hr} />
        )}

      <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
      {dropOffCount > 1 && <IconProvider Icon={DRAG} size='16' style={{ cursor: "pointer" }} />}

        {(orderTypeActive == "Ondemand" && dropOffCount > 1) ? <span className={styles.dropNumber} style={{ marginInlineEnd: "2px" }}>{index + 1}</span> : <IconProvider Icon={DROPOFF} size='16' />}

        <Typography text={t("Deliver to")} weight='Body_Middle_Bold' style={{ lineHeight: "15px"}} />
{props.address.length == 0 && <span className={styles.starRequired}>*</span>}
{ActivescheduleSetting && <Schedule orderType={detectOrderType()}
                  scheduleDateBefore={props.scheduleDateBefore}
                  scheduleDateAfter={props.scheduleDateAfter}
                  firstDropOff={first}
          id={id}
          type={"delivery"}
                /> }
      </div>

      <div className={styles.PickupOnlyNewOrderContainerSecondRow}>
        <SearchList  DefaultListPreview={(isEmpty(props.address) &&  servicepoints && deliveryLocationType != "address" &&  servicepoints.length > 0  ) && <div className={styles.DefaultListPreview}>
            <Typography weight='Body_Tiny_Medium' text={t("All Service points")} style={{ marginTop: "16px", marginBottom: "4px" , width:"100%",width:"calc(100% - 24px)",marginInlineStart:"12px",marginInlineEnd:"12px",marginTop:"8px",color:"#484848"}} />
            <div className={styles.DefaultListItemsContainerPreview}>
              {servicepoints.map((item)=>{
                return <ServicePoint_addressItem data={item} onclick={() => { GetserachListItemOnclickSP(item) }} />
              })}
            </div>

        </div>} 
                inputIcon={<img src={deliveryLocationType == "address" ? location_gray : service_point} />} 
        onChange={deliveryLocationType == "address" ? (e) => handlePickUpInputs(e, "address") : (e) => handleSearchSPInput(e, "address")} 

        style={{ zIndex: "1" }} 
        value={props.address} 
        placeHolder={deliveryLocationType == "address" ? t("Search and select address") : t("Search and select service point")}

        isloading={deliveryLocationType == "address" ? suggestListPickUpDropOffLoading : servicepointsIsLoading}
        listItemOnclick={deliveryLocationType == "address" ? handleList  : GetserachListItemOnclickSP}
        error={GetSearchListError()} 
        errorDescription={GetSearchListError()?.errorDescription} 
        errorTitle={GetSearchListError()?.errorTitle} 
        errorIcon={GetSearchListError()?.errorIcon} 
        errorActionOnClick={(e) => handlePickUpInputs({target:{value:""}}, "address")} 
        errorActionTitle={GetSearchListError()?.errorActionTitle}
        ListItemChildren={deliveryLocationType == "address" ? GetserachListItem() : ServicePoint_addressItem}
        list={serachListData()} 
        />
       {deliveryLocationType == "address" && <Button iconComponentChildren={<IconProviderSvgModifier Icon={LOCATION} size='16' />}   size='Medium' type='Secondary' style={{ marginInlineEnd: "7px" }} onClick={ChooseoOnMap} isActive={destinationShow} />}
       {deliveryLocationType == "address" && <Button  iconComponentChildren={<IconProviderSvgModifier Icon={ADDRESS_BOOK} size='16' />}   size='Medium' type='Secondary'  onClick={handleOpenAddressbook} isActive={addressBookSource} />}
        {(orderTypeActive == "Ondemand" && !first && dropOffCount > 1) && <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={() => (orderTypeActive == "Ondemand" && !first && dropOffCount > 1) ? removeDrop(id) : resetPickup()} />}

      </div>

      {props.address.length > 0  && <Typography text={t("Please select address from search results")} weight='Body_Small_Regular' style={{
          width: "345px", overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"  ,marginTop:"-6px"  
        }} textColor='Red' />}
    </div>
  }

  return (
    <>

      <div className={clsx(styles.PickupOnlyNewOrderSelectedContainer, styles[orderTypeActive])}>
      
                <div className={styles.PickupOnlyNewOrderContainerFirstRow} style={{width:"100%"}}>
                {dropOffCount > 1 && <IconProvider Icon={DRAG} size='16' style={{ cursor: "pointer" }} />}

                {(orderTypeActive == "Ondemand" && dropOffCount > 1) ? <span className={styles.dropNumber} style={{ marginInlineEnd: "2px" }}>{index + 1}</span> : <IconProvider Icon={DROPOFF} size='16' />}
                <Typography text={t("Deliver to")} weight='Body_Middle_Bold' style={{marginInlineEnd:"auto"}} />

        {ActivescheduleSetting && <Schedule orderType={detectOrderType()}
                  scheduleDateBefore={props.scheduleDateBefore}
                  scheduleDateAfter={props.scheduleDateAfter}
                  firstDropOff={first}
          id={id}
          type={"delivery"}
                /> }
       {/* {!pickupRequiredCheck() && <span className={styles.starRequired}>*</span>} */}
      </div>
        <div className={styles.PickupOnlyNewOrderSelectedContainerFrow}  style={{marginTop:(props.name && props.name.length > 0) && "4px"}}>
        {(props.name && props.name.length > 0) && <img src={service_point} />}
          <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: "1" }}>
            {(props.name && props.name.length > 0) && <Typography text={props.name} weight='Body_Middle_Regular' style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />}
            <Typography text={props.address} weight={(props.name && props.name.length > 0) ? "Body_Tiny_Regular" : 'Body_Middle_Regular'} style={{
            width: "293px", overflow: 'hidden',
            textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px", color : (props.name && props.name.length > 0) ? "rgba(128, 128, 128, 1)" : 'rgba(72, 72, 72, 1)'
          }} />
          </div>

          {checkInputFilledByAB() ?
          <Button disabled={!UserHavePermission()} onClick={() => { setModalDelActive(true) }} size='Medium' type='Secondary' iconComponentChildren={<IconProviderSvgModifier Icon={Bookmarkactive} size='16' />} >  </Button>
          : <Button onClick={() => { setModalAddActive(true) }} size='Medium' type='Secondary' iconComponentChildren={<IconProviderSvgModifier Icon={BookmarkInActive} size='16' />} >  </Button>
        }
          {/* <Button  iconComponentChildren={<IconProviderSvgModifier Icon={INFO_CIRCLE} size='16' />}  size='Medium' type='Secondary' badge={ !pickupRequiredCheck() && true} onClick={handleShowInfo} isActive={activePickupDropOff.id == id} /> */}
          <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={() => (orderTypeActive == "Ondemand" && !first && dropOffCount > 1) ? removeDrop(id) : resetPickup()} />

        </div>


       {/* {( !pickupRequiredCheck()) && <Typography text={t("Complete * Feileds")} weight='Body_Small_Regular' style={{
          width: "345px", overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"
        }} textColor='Red' />}  */}

<DeliveryInfoNewOrder {...props} id={id} first={first} handleShowInfo={handleShowInfo} pickupRequiredCheck={pickupRequiredCheck()} />

      </div>

      { modalAddActive && <Modal  onclose={()=>{setModalAddActive(false)}} 
      
      body={<div className={styles.addAddressbookContainer}>
          <div className={styles.addAddressbookinnerContainer} style={{paddingBottom : "16px" ,borderBottom:"1px solid #F4F4F7"}}> 
                <Input title={t("title")}  type={"text"} placeHolder={t("ExHome")} value={modalAddData.title} onChange={(e)=>{setModalAddData({title : e.target.value , code : modalAddData.code})}}/>
                <Input title={t('Code')}  type={"text"} placeHolder={t("Ex123")} value={modalAddData.code}  onChange={(e)=>{setModalAddData({title : modalAddData.title , code : e.target.value})}}/>

          </div>
          <div className={styles.addAddressbookinnerContainer} style={{paddingTop:"16px" }}> 
              
              <div className={styles.addAddressnamephoneContainer}>
                <IconProvider Icon={DROPOFF} size='16' />
                <div className={styles.addAddressnamephoneInnerContainer}>
                  <Typography weight='Body_Middle_Medium' text={props.address} style={{lineHeight : "16.71px"}} />
                  <Typography weight='Body_Tiny_Regular' text={isEmpty(addressDetail) ? "-" : addressDetail} />
                </div>
              </div>

      
             {(!isEmpty(senderFullName) || !isEmpty(senderPhoneNumber)) && <div className={styles.addAddressnamephoneContainer} style={{borderTop:"1px solid rgb(244, 244, 247)",paddingTop:"12px"}}>
                <IconProvider Icon={PERSON} size='16' style={{alignSelf :"center"}} />
                <div className={styles.addAddressnamephoneInnerContainer}>
                  <Typography weight='Body_Middle_Medium' text={isEmpty(senderFullName) ? "--" : senderFullName} style={{lineHeight : "17.3px"}} />
                  <Typography weight='Body_Tiny_Regular' text={isEmpty(senderPhoneNumber) ? "-" : senderPhoneNumber}  />
                </div>
               {!isEmpty(email) && <Typography style={{alignSelf :"end" , marginInlineStart :"auto"}} weight='Subtitle_Tiny_Regular' text={email}  />}

              </div>}

          </div>
      </div>} ConfirmationDisabled={isEmpty(modalAddData.title)} size='Large' CancelText={t("Cancel")} CancelOnClick={()=>{setModalAddActive(false)}} ConfirmationOnClick={handleNewBookmark} ConfirmationText={t("Add")} icon={WARNING} title={t('Addtoaddressbook')} description='This address with entered details will be address to your address book.'  />  }
         { modalDelActive && <Modal size='Small' ConfirmationStyle={{color:"white",backgroundColor:"red"}} CancelText={t("Cancel")} CancelOnClick={()=>{setModalDelActive(false)}} ConfirmationOnClick={RemoveAddressBook} ConfirmationText={t("YesRemove")} icon={WARNING} title={t('Remove from addressbook?')} description={t("RemovefromaddressbookDesc")}  />}

      {/* {activePickupDropOff.id == id && <DeliveryInfoNewOrder {...props} id={id} first={first} handleShowInfo={handleShowInfo} />} */}
    </>

  )
}

export default DeliveryNewOrder